import { render, staticRenderFns } from "./HeaderFive.vue?vue&type=template&id=49cc8b0f&scoped=true&"
import script from "./HeaderFive.vue?vue&type=script&lang=js&"
export * from "./HeaderFive.vue?vue&type=script&lang=js&"
import style0 from "./HeaderFive.vue?vue&type=style&index=0&id=49cc8b0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cc8b0f",
  null
  
)

export default component.exports